import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  labelBox: {
    fontFamily: "Eurostile !important",
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    border: "2px solid #dbdbdb",
    marginTop: "16px !important",
    background: "#CDF9D3",
    // paddingTop:'7px !important',
    paddingBottom: "6px",
    paddingLeft: "8px !important",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    height: "36px",
    fontSize:'18px !important',
    color:'#333333',
    fontWeight:600
  },
  gridDetails: {
    textAlign: "center",
    padding: "4px",
    border: "0px",
    background: "#fafafa",
    fontWeight: 500,
    fontSize: "14px",
  },
  gridLabelDetails: {
    textAlign: "center",
    padding: "4px",
    border: "0px",
    background: "#fafafa",
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: 'Eurostile !important',
  },
});

export default useStyles;
